var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center"},[_c('md-icon',{staticStyle:{"width":"150px","height":"150px"}},[_vm._v("cloud_off")]),_c('h3',[_vm._v(_vm._s(_vm.gt("no_internet_connection")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }